import React from 'react';
import styled from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import { SuccessButton } from 'components/button';
import { Controller, useForm } from 'react-hook-form';
import { CommonStyledComponentProps } from '__utils/type';
import moment from 'moment';
import Footer from 'components/footer';
import { useHistory } from 'react-router-dom';
import { DatePicker } from 'antd';
import { useSelector } from 'react-redux';
import { propsToJS } from '__utils/immutable-to-js';
import { PaymentFlowHelper } from '../paymentFlow.helper';
import { isMintproApp, redirectToOld } from '__utils/common-utils';
import PaymentViewSelector from 'views/payment-flow/payment-flow.selector';
import { FormErrorMessageSpan, InputMintDiv } from 'views/common-styled-components';

const Container = styled.div`
    label {
        font-size: 14px;
    }
    input::-webkit-input-placeholder {
        font-size: 16px;
        color: #a1a6a7;
    }

`;
const SubmitButton = styled(SuccessButton) <CommonStyledComponentProps>`
    font-size: 16px;
    font-weight: normal ;

`;

const ChequeForm: React.FC = () => {
    const history = useHistory();
    const dateFormat = 'DD/MM/YYYY';
    const { makeBSEpayment } = PaymentFlowHelper();
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const { register, handleSubmit, formState: {errors}, control } = useForm({ mode: 'onChange' });
    const { userPaymentDetailView } = propsToJS(useSelector(PaymentViewSelector));

    const orderNoParam = window.location.search?.split('?orderNo=')[1];

    const onChequeSuccess = (bsePaymentResponse: any) => {
        console.log('bsePaymentResponse',bsePaymentResponse);

        if (bsePaymentResponse) {
            downloadChallan(bsePaymentResponse);
        }
        else {
            history.push(`thank-you?orderNo=${orderNoParam}`);
        }
    }

    const downloadChallan = (bsePaymentResponse: any) => {
        if (isMobile && isMintproApp())
        {
            var featurePayload = {
                type: 'download',
                payload: {
                    fileName: 'challan',
                    fileUrl: `https://www.turtlemintmoney.com${bsePaymentResponse}`,
                    fileType: 'application/pdf',
                },
                
            };
            window.postMessage(JSON.stringify(featurePayload), '*');
            setTimeout(() => {
            history.push(`thank-you?orderNo=${orderNoParam}`);

            }, 2000);
        }
        else
        {
            window.open(`https://www.turtlemintmoney.com${bsePaymentResponse}`, '_blank', 'noopener')?.focus();
            setTimeout(() => {
                history.push(`thank-you?orderNo=${orderNoParam}`);

            }, 2000);
        }
    }

    const onSubmitGenerateChequeDetails = (chequeDetails: any): void => {
        makeBSEpayment({ paymentMode: 1, chequeDate: moment(chequeDetails.chequeDate).format('DD/MM/YYYY'), chequeNumber: chequeDetails.chequeNumber }, onChequeSuccess);
    };

    return (<Container>
        <form name="chequeDetailsForm" id="chequeDetailsForm" onSubmit={ handleSubmit(onSubmitGenerateChequeDetails) }>
            <div className="chalanContent">
                <label>Date On Cheque</label>
                <br />
                <Controller
                    control={ control }
                    name='chequeDate'
                    rules={ { required: "Please enter cheque date." } }
                    render={ ({ onChange }) => (
                        <DatePicker
                            allowClear={ false }
                            format={ dateFormat }
                            onChange={ (e) => onChange(e) }
                            placeholder='DD/MM/YYYY'
                            disabledDate={ date => date.isBefore(moment().subtract(70, 'days')) || date.isAfter(new Date()) }
                            style={ { height: "41px", marginTop: "4px", width: "100%" } }
                        />
                    ) }
                />
                { errors.chequeDate ? <FormErrorMessageSpan style={ { fontSize: "14px" } }>{ errors.chequeDate.message }</FormErrorMessageSpan> : null }
            </div>
            <div className="chalanContent" style={ { marginTop: '10px' } }>
                <InputMintDiv>
                    <label>Cheque Number
                        <span className="hoverTip"> <b className="infoIcon">&#8505;</b>
                            <div className="tooltipChalan">
                                The six-digit number written at the bottom left-hand corner of the
                                cheque is the cheque number.
                            </div>
                        </span>
                    </label>
                    <br />
                    <input
                        name='chequeNumber'
                        type="number"
                        placeholder="XXXXXX"
                        ref={register({

                            required: "Please enter your Cheque number",
                            pattern: {
                                value: /^\d{6}$/,
                                message: "Please enter valid Cheque number"
                            }
                        }) }
                    />
                    { errors.chequeNumber ? <FormErrorMessageSpan style={ { fontSize: "14px" } }>{ errors.chequeNumber.message }</FormErrorMessageSpan> : null }
                    <p style={ { padding: "10px 0", color: "#959595", marginBottom: '8px' } }>Please note that the cheque needs to be drawn on the
                        registered bank account.</p>
                </InputMintDiv>
            </div>
        </form>
        { isMobile ?
            <Footer>
                <SubmitButton type="submit" isMobile={ isMobile } form="chequeDetailsForm" >Generate Challan</SubmitButton>
            </Footer>
            : <SubmitButton type="submit" isMobile={ isMobile } form="chequeDetailsForm" >Generate Challan</SubmitButton>
        }
    </Container>);
};

export default ChequeForm;

